import React from "react";
import { connect } from 'react-redux';
import moment from "moment";
import Skeleton from '@material-ui/lab/Skeleton';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import StanceBeamTripleBarChart from '../../../../../../components/Charts/StanceBeamTripleBarChart';
import CardBox from '../../../../../../components/CardBox';
import StanceBeamBarChart from '../../../../../../components/Charts/StanceBeamBarChart';
import StanceBeamDoubleBarChart from '../../../../../../components/Charts/StanceBeamDoubleBarChart';
import InsightMessages from './InsightMessages.js'
import IntlMessages from "../../../../../../util/IntlMessages";
import { Progress } from "reactstrap";
import wagonWheelImage from "../../../../../../assets/images/images/wagon-wheel.png";

class Insight extends React.Component {
    constructor() {
        super()
        this.state = {
            overallVisibility: "block",
            verticalVisibility: "block",
            horizontalVisibility: "block",
            speedData: [{
                x: "",
                "Max Bat Speed": "",
                "Bat Speed at Impact": ""
            }],
            backliftDirectionData: [{
                x: "",
                "Backlift Direction Angle": ""
            }],
            batFaceData: [{
                x: "",
                "Bat Face Angle": ""
            }],
            efficiencyData: [{
                x: "",
                "Efficiency": ""
            }],
            timeToImpactData: [{
                x: "",
                "Time to Impact": ""
            }],
            verticalBackliftData: [{
                x: "",
                "Backlift Angle": ""
            }],
            horizontalBackliftData: [{
                x: "",
                "Backlift Angle": ""
            }],
            verticalDownswingData: [{
                x: "",
                "Downswing Angle": ""
            }],
            horizontalDownswingData: [{
                x: "",
                "Downswing Angle": ""
            }],
            powerData: [{
                x: "",
                "Power": ""
            }]
        }
    }

    componentDidMount() {
        if (this.props.sessionDataLoader === false && this.props.sessionDataError === null && this.props.sessionData != null) {
            this.setSectionVisibility()
        }
        if (this.props.swingList.length > 0 && this.props.swingListLoader === false && this.props.sessionData != null && this.props.sessionData.id === this.props.sessionId) {
            this.drawSwingGraphs()
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.sessionDataLoader === true && this.props.sessionDataLoader === false && this.props.sessionDataError === null && this.props.sessionData != null) {
            this.setSectionVisibility()
        }
        if (this.props.swingList.length > 0 && prevProps.swingListLoader === true && this.props.swingListLoader === false && this.props.sessionData != null && this.props.sessionData.id === this.props.sessionId) {
            this.drawSwingGraphs()
        }
    }
    setSectionVisibility() {
        if (this.props.sessionData !== null) {
            if (!this.props.sessionData.insightOverallStats) {
                this.setState({
                    overallVisibility: "none"
                })
            }
            if (this.props.sessionData.insightVerticalStats) {
                this.setState({
                    verticalVisibility: (Math.round(parseFloat(this.props.sessionData.insightVerticalStats[0])) >= 5) ? "block" : "none"
                })
            } else {
                this.setState({
                    verticalVisibility: "none"
                })
            }
            if (this.props.sessionData.insightHorizontalStats) {
                this.setState({
                    horizontalVisibility: (Math.round(parseFloat(this.props.sessionData.insightHorizontalStats[0])) >= 5) ? "block" : "none"
                })
            } else {
                this.setState({
                    horizontalVisibility: "none"
                })
            }
        }
    }
    getPlayerPer(totalSwing, playedSwing) {
        return ((playedSwing > 0) && (totalSwing > 0)) ? Math.round(((100 * playedSwing) / totalSwing)) : 0
    }
    getMissedPer(totalSwing, playedSwing) {
        return (totalSwing > 0) ? ((playedSwing > 0) ? (100 - Math.round(((100 * playedSwing) / totalSwing))) : 100) : 0
    }
    getOverallChartData() {
        var overallChartData = [{
            "AnswerRef": "one",
            "Text": "Powerful",
            "Score": 0,
            "RespondentPercentage": 0,
            "Rank": 1
        },
        {
            "AnswerRef": "the",
            "Text": "Attacking",
            "Score": 0,
            "RespondentPercentage": 0,
            "Rank": 2
        },
        {
            "AnswerRef": "three",
            "Text": "Defensive",
            "Score": 0,
            "Defensive": 0,
            "Rank": 3
        }]
        if (this.props.sessionData.insightOverallStats) {
            overallChartData = [
                {
                    "color": "#FF4600",
                    "Text": "Powerful",
                    "Score": 0,
                    "RespondentPercentage": parseInt(this.props.sessionData.insightOverallStats[3]),
                    "Rank": 1
                },
                {
                    "color": "#F7C224",
                    "Text": "Attacking",
                    "Score": 0,
                    "RespondentPercentage": parseInt(this.props.sessionData.insightOverallStats[2]),
                    "Rank": 2
                },
                {
                    "color": "#658DEC",
                    "Text": "Defensive",
                    "Score": 0,
                    "RespondentPercentage": parseInt(this.props.sessionData.insightOverallStats[1]),
                    "Rank": 3
                }
            ]
        }
        return overallChartData
    }

    getVerticalChartData() {
        var verticalChartData = [{
            "AnswerRef": "one",
            "Text": "Powerful",
            "Score": 0,
            "RespondentPercentage": 0,
            "Rank": 1
        },
        {
            "AnswerRef": "the",
            "Text": "Attacking",
            "Score": 0,
            "RespondentPercentage": 0,
            "Rank": 2
        },
        {
            "AnswerRef": "three",
            "Text": "Defensive",
            "Score": 0,
            "Defensive": 0,
            "Rank": 3
        }]
        if (this.props.sessionData.insightOverallStats) {
            verticalChartData = [
                {
                    "color": "#FF4600",
                    "Text": "Powerful",
                    "Score": 0,
                    "RespondentPercentage": parseInt(this.props.sessionData.insightVerticalStats[3]),
                    "Rank": 1
                },
                {
                    "color": "#F7C224",
                    "Text": "Attacking",
                    "Score": 0,
                    "RespondentPercentage": parseInt(this.props.sessionData.insightVerticalStats[2]),
                    "Rank": 2
                },
                {
                    "color": "#658DEC",
                    "Text": "Defensive",
                    "Score": 0,
                    "RespondentPercentage": parseInt(this.props.sessionData.insightVerticalStats[1]),
                    "Rank": 3
                }
            ]
        }
        return verticalChartData
    }

    getHorizontalChartData() {
        var horizontalChartData = [{
            "AnswerRef": "one",
            "Text": "Powerful",
            "Score": 0,
            "RespondentPercentage": 0,
            "Rank": 1
        },
        {
            "AnswerRef": "the",
            "Text": "Attacking",
            "Score": 0,
            "RespondentPercentage": 0,
            "Rank": 2
        }]
        if (this.props.sessionData.insightOverallStats) {
            horizontalChartData = [
                {
                    "color": "#FF4600",
                    "Text": "Powerful",
                    "Score": 0,
                    "RespondentPercentage": parseInt(this.props.sessionData.insightHorizontalStats[2]),
                    "Rank": 1
                },
                {
                    "color": "#F7C224",
                    "Text": "Attacking",
                    "Score": 0,
                    "RespondentPercentage": parseInt(this.props.sessionData.insightHorizontalStats[1]),
                    "Rank": 2
                }
            ]
        }
        return horizontalChartData
    }

    getOverallStatsVisibility() {
        if (this.props.sessionData !== null) {
            if (this.props.sessionData.insightOverallStats) {
                return "block"
            } else {
                return "none"
            }

        } else {
            return "block"
        }
    }
    getVerticalStatsVisibility() {
        if (this.props.sessionData !== null && this.props.sessionData.insightVerticalStats) {
            return (Math.round(parseFloat(this.props.sessionData.insightVerticalStats[0])) >= 5) ? "block" : "none"
        } else {
            return "none"
        }
    }
    getHorizontalStatsVisibility() {
        if (this.props.sessionData !== null && this.props.sessionData.insightHorizontalStats) {
            return (Math.round(parseFloat(this.props.sessionData.insightHorizontalStats[0])) >= 5) ? "block" : "none"
        } else {
            return "none"
        }
    }

    renderSessionSummary() {
        return (
            <div>
                <div>
                    {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                        <Skeleton animation="wave" variant="rect" className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center" style={{ height: 64 }} />
                    ) : (
                            <div style={{ padding: '20px 20px 20px 20px' }} className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center ">
                                <h2 className="title mb-3 mb-sm-0">{<IntlMessages id="mySession.insight.sessionInsight" />} <span className="h4">- {moment(this.props.sessionData.completionDateTs).format('Do MMM YYYY')} at {moment(this.props.sessionData.completionDateTs).format('h:mm:ss a')}</span></h2>
                            </div>
                        )}
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12" style={{ paddingRight: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.wagonWheel" /></h4>
                            </div>
                            <div className="stack-order py-4 px-2 component-height">
                                {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <Skeleton animation="wave" variant="rect" className="wagon-wheel-img" />
                                ) : (
                                        <div className="img-overlay-card ripple-effect" style={{ marginBottom: '10px' }}>
                                            <div className="center-crop-img wagon-wheel-img">
                                                <img src={wagonWheelImage} className="img-responsive" alt="" />
                                            </div>
                                            <div className="jr-cart-ab">
                                                <div className="row text-center w-100 wagon-wheel-first">
                                                    <div className="col-sm-6 col-6 text-truncate wagon-wheel-second">
                                                        <div>{this.props.sessionData.offSidePlayed}</div>
                                                        <div className="wagon" style={{ fontSize: '12px', marginTop: '-6px' }}>Off Side</div>
                                                    </div>
                                                    <div className="col-sm-6 col-6 text-truncate wagon-wheel-third">
                                                        <div>{this.props.sessionData.onSidePlayed}</div>
                                                        <div className="" style={{ fontSize: '12px', marginTop: '-6px' }}>On Side</div>
                                                    </div>
                                                </div>
                                                <div className="row text-center w-100 wagon-wheel-forth">
                                                    <div className="col-sm-12 col-12 text-truncate" >
                                                        <div>{this.props.sessionData.straightPlayed}</div>
                                                        <div style={{ fontSize: '12px', marginTop: '-6px' }}>Straight</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                <div className="row">
                                    <div className="col-sm-12">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="h3" />
                                        ) : (
                                                <div className="h3">
                                                    <span>Total Shots</span><span className="h2"> {this.props.sessionData.totalShots}</span>
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12" style={{ paddingRight: '5px', paddingLeft: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.playedShots" /></h4>
                            </div>
                            <div className="stack-order py-4 px-2 component-height">
                                <div className="p-3">
                                    {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                        <Skeleton animation="wave" variant="rect" className="d-flex flex-row p-0 mt-3 mb-4 my-1" style={{ height: 30 }} />
                                    ) : (
                                            <div>
                                                <div className="d-flex flex-row p-0 mt-3">
                                                    <p className="m-0">Played | {this.props.sessionData.played}</p>
                                                    <p className="ml-auto m-0">{this.getPlayerPer(this.props.sessionData.totalShots, this.props.sessionData.played)}%</p>
                                                </div>
                                                <Progress className="shadow-sm mb-4 my-1" style={{ height: 6 }} color={'#008CD5'} value={this.getPlayerPer(this.props.sessionData.totalShots, this.props.sessionData.played)} />
                                            </div>
                                        )}
                                    {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                        <Skeleton animation="wave" variant="rect" className="d-flex flex-row p-0 mt-3 mb-4 my-1" style={{ height: 30 }} />
                                    ) : (
                                            <div>
                                                <div className="d-flex flex-row">
                                                    <p className="m-0">Missed | {this.props.sessionData.totalShots - this.props.sessionData.played}</p>
                                                    <p className="ml-auto m-0">{this.getMissedPer(this.props.sessionData.totalShots, this.props.sessionData.played)}%</p>
                                                </div>
                                                <Progress className="shadow-sm my-1" style={{ height: 6 }} color="warning" value={this.getMissedPer(this.props.sessionData.totalShots, this.props.sessionData.played)} />
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-4 col-sm-12 col-12" style={{ paddingLeft: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.highlights" /></h4>
                            </div>
                            <div className="stack-order py-1 px-2 component-height">
                                <div className="row pb-4">
                                    <div className="col-lg-6 col-md-6 col-sm-3 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.maxBatSpeedStats[0]))} maxValue={79} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#0099FF',
                                                        textColor: '#f88',
                                                        trailColor: '#c3e4fa',
                                                        backgroundColor: '#3e98c7'
                                                    })}>
                                                        <div style={{ fontSize: '18px' }}>
                                                            {Math.round(parseFloat(this.props.sessionData.maxBatSpeedStats[0]))}
                                                        </div>
                                                        <div style={{ fontSize: '10px', lineHeight: 0.5 }}>Km/h</div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                        <div><IntlMessages id="sidebar.maxBatSpeed" /></div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-3 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.speedAtImpactStats[0]))} maxValue={79} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#00FF44',
                                                        textColor: '#f88',
                                                        trailColor: '#bdffce',
                                                        backgroundColor: '#3e98c7'
                                                    })}>
                                                        <div style={{ fontSize: '18px' }}>
                                                            {Math.round(parseFloat(this.props.sessionData.speedAtImpactStats[0]))}
                                                        </div>
                                                        <div style={{ fontSize: '10px', lineHeight: 0.5 }}>Km/h</div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                        <div><IntlMessages id="sidebar.maxImpactSpeed" /></div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-3 col-6 circular-pad">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.efficiencyStats[0]))} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#FFCC00',
                                                        textColor: '#f88',
                                                        trailColor: '#fceeb6',
                                                        backgroundColor: '#3e98c7',
                                                    })}>
                                                        <div style={{ fontSize: '18px' }}>
                                                            <span>{Math.round(parseFloat(this.props.sessionData.efficiencyStats[0]))}%</span>
                                                        </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                        <div><IntlMessages id="mySession.insight.maxEfficiency" /></div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-3 col-6 circular-pad">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.powerFactorStats[0]))} maxValue={2400} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#5D00FF',
                                                        textColor: '#f88',
                                                        trailColor: '#d3baff',
                                                        backgroundColor: '#3e98c7',
                                                    })}>
                                                        <div style={{ fontSize: '18px' }}>
                                                            <span>{Math.round(parseFloat(this.props.sessionData.powerFactorStats[0]))}</span>
                                                        </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                        <div><IntlMessages id="sidebar.maxPower" /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderSessionOverall() {
        return (
            <div style={{ display: this.state.overallVisibility }}>
                <div className="row" style={{ backgroundColor: 'rgb(204, 204, 204, .5)', marginRight: '-2px', marginLeft: '-2px', minHeight: '200px', marginBottom: '-150px' }}>
                    <div className="col-sm-12 text-center h2 pt-3 pb-1">Overall</div>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-7 col-12" style={{ paddingRight: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.totalShots" /> -
                                {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? '' : this.props.sessionData.totalShots}
                                </h4>
                            </div>
                            {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                <Skeleton animation="wave" variant="rect" className="stack-order py-4 px-2 stat-min-height" />
                            ) : (
                                    <div className="stack-order py-4 px-2 stat-min-height">
                                        <StanceBeamTripleBarChart chartData={this.getOverallChartData()} firstBarColor="#FF4600" secondBarColor="#F7C224" thirdBarColor="#658DEC" />
                                    </div>
                                )}
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-5 col-12" style={{ paddingRight: '5px', paddingLeft: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.stats" /></h4>
                            </div>
                            <div className="stack-order py-4 px-2 stat-min-height">
                                <div className="row pb-4" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="col-md-6 col-sm-12 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="stat-circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="stat-circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={this.getPlayerPer(this.props.sessionData.totalShots, this.props.sessionData.played)} maxValue={100} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#5D00FF',
                                                        textColor: '#f88',
                                                        trailColor: '#d3baff',
                                                        backgroundColor: '#3e98c7',
                                                    })}>
                                                        <div style={{ fontSize: '16px' }}>
                                                            {this.getPlayerPer(this.props.sessionData.totalShots, this.props.sessionData.played)} %
                                                        </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 stat-circular-progress">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 30 }} />
                                        ) : (
                                                <IntlMessages id="mySession.insight.hitPercentage" />
                                            )}
                                    </div>
                                </div>
                                <div className="row pb-4" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="col-md-6 col-sm-12 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="stat-circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="stat-circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.efficiencyStats[2]))} maxValue={100} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#FFCC00',
                                                        textColor: '#f88',
                                                        trailColor: '#fceeb6',
                                                        backgroundColor: '#3e98c7',
                                                    })}>
                                                        <div style={{ fontSize: '16px' }}>
                                                            {Math.round(parseFloat(this.props.sessionData.efficiencyStats[2]))}%
                                                        </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 stat-circular-progress">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 30 }} />
                                        ) : (
                                                <IntlMessages id="mySession.insight.avgEfficiency" />
                                            )}
                                    </div>
                                </div>
                                <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="col-md-6 col-sm-12 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="stat-circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="stat-circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.timeToImpactStats[2]))} maxValue={300} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#0099FF',
                                                        textColor: '#f88',
                                                        trailColor: '#c3e4fa',
                                                        backgroundColor: '#3e98c7'
                                                    })}>
                                                        <div style={{ fontSize: '16px' }}>
                                                            {Math.round(parseFloat(this.props.sessionData.timeToImpactStats[2]))}
                                                        </div>
                                                        <div style={{ fontSize: '10px', lineHeight: 0.5 }}>ms</div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 stat-circular-progress">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 30 }} />
                                        ) : (
                                                <IntlMessages id="mySession.insight.avgImpactTime" />
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-12" style={{ paddingLeft: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.facts" /></h4>
                            </div>
                            <div className="stack-order py-4 px-2 stat-min-height">
                                {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <div>
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                    </div>
                                ) : (
                                        <InsightMessages feature="overall" featureData={this.props.sessionData.insightOverallMessages} />
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderSessionVertical() {
        return (
            <div style={{ display: this.state.verticalVisibility }}>
                <div className="row" style={{ backgroundColor: 'rgb(204, 204, 204, .5)', marginRight: '-2px', marginLeft: '-2px', minHeight: '200px', marginBottom: '-150px' }}>
                    <div className="col-sm-12 text-center h2 pt-3 pb-1">Vertical Swings</div>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-7 col-12" style={{ paddingRight: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.verticalShots" /> -
                                {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? '' : Math.round(parseFloat(this.props.sessionData.insightVerticalStats[0]))}
                                </h4>
                            </div>
                            {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                <Skeleton animation="wave" variant="rect" className="stack-order py-4 px-2 stat-min-height" />
                            ) : (
                                    <div className="stack-order py-4 px-2 stat-min-height">
                                        <StanceBeamTripleBarChart chartData={this.getVerticalChartData()} firstBarColor="#FF4600" secondBarColor="#F7C224" thirdBarColor="#658DEC" />
                                    </div>
                                )}
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-5 col-12" style={{ paddingRight: '5px', paddingLeft: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.consistency" /></h4>
                            </div>
                            <div className="stack-order py-4 px-2 stat-min-height">
                                <div className="row pb-4" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="col-md-6 col-sm-12 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="stat-circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="stat-circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.insightVerticalConsistency[0]))} maxValue={100} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#5D00FF',
                                                        textColor: '#f88',
                                                        trailColor: '#d3baff',
                                                        backgroundColor: '#3e98c7',
                                                    })}>
                                                        <div style={{ fontSize: '16px' }}>
                                                            {Math.round(parseFloat(this.props.sessionData.insightVerticalConsistency[0]))}%
                                            </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 stat-circular-progress">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 30 }} />
                                        ) : (
                                                <IntlMessages id="mySession.insight.backliftAngle" />
                                            )}
                                    </div>
                                </div>
                                <div className="row pb-4" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="col-md-6 col-sm-12 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="stat-circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="stat-circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.insightVerticalConsistency[1]))} maxValue={100} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#FFCC00',
                                                        textColor: '#f88',
                                                        trailColor: '#fceeb6',
                                                        backgroundColor: '#3e98c7',
                                                    })}>
                                                        <div style={{ fontSize: '16px' }}>
                                                            {Math.round(parseFloat(this.props.sessionData.insightVerticalConsistency[1]))}%
                                            </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 stat-circular-progress">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 30 }} />
                                        ) : (
                                                <IntlMessages id="mySession.insight.backliftDirectionAngle" />
                                            )}
                                    </div>
                                </div>
                                <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="col-md-6 col-sm-12 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="stat-circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="stat-circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.insightVerticalConsistency[2]))} maxValue={100} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#0099FF',
                                                        textColor: '#f88',
                                                        trailColor: '#c3e4fa',
                                                        backgroundColor: '#3e98c7'
                                                    })}>
                                                        <div style={{ fontSize: '16px' }}>
                                                            {this.props.sessionData.insightVerticalConsistency[2]}%
                                            </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 stat-circular-progress">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 30 }} />
                                        ) : (
                                                <IntlMessages id="mySession.insight.batfaceAngle" />
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-12" style={{ paddingLeft: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.facts" /></h4>
                            </div>
                            <div className="stack-order py-4 px-2 stat-min-height">
                                {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <div>
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                    </div>
                                ) : (
                                        <InsightMessages feature="vertical" featureData={this.props.sessionData.insightVerticalMessages} />
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderSessionHorizontal() {
        return (
            <div style={{ display: this.state.horizontalVisibility }}>
                <div className="row" style={{ backgroundColor: 'rgb(204, 204, 204, .5)', marginRight: '-2px', marginLeft: '-2px', minHeight: '200px', marginBottom: '-150px' }}>
                    <div className="col-sm-12 text-center h2 pt-3 pb-1">Horizontal Swings</div>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-7 col-12" style={{ paddingRight: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.horizontalShots" /> -
                                {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? '' : Math.round(parseFloat(this.props.sessionData.insightHorizontalStats[0]))}
                                </h4>
                            </div>
                            {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                <Skeleton animation="wave" variant="rect" className="stack-order py-4 px-2 stat-min-height" />
                            ) : (
                                    <div className="stack-order py-4 px-2 stat-min-height">
                                        <StanceBeamTripleBarChart chartData={this.getHorizontalChartData()} firstBarColor="#FF4600" secondBarColor="#F7C224" thirdBarColor="#658DEC" />
                                    </div>
                                )}
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-5 col-12" style={{ paddingRight: '5px', paddingLeft: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.consistency" /></h4>
                            </div>
                            <div className="stack-order py-4 px-2 stat-min-height">
                                <div className="row pb-4" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="col-md-6 col-sm-12 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="stat-circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="stat-circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.insightHorizontalConsistency[0]))} maxValue={100} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#5D00FF',
                                                        textColor: '#f88',
                                                        trailColor: '#d3baff',
                                                        backgroundColor: '#3e98c7',
                                                    })}>
                                                        <div style={{ fontSize: '16px' }}>
                                                            {Math.round(parseFloat(this.props.sessionData.insightHorizontalConsistency[0]))}%
                                            </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 stat-circular-progress">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 30 }} />
                                        ) : (
                                                <IntlMessages id="mySession.insight.backliftAngle" />
                                            )}
                                    </div>
                                </div>
                                <div className="row pb-4" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="col-md-6 col-sm-12 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="stat-circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="stat-circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.insightHorizontalConsistency[1]))} maxValue={100} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#FFCC00',
                                                        textColor: '#f88',
                                                        trailColor: '#fceeb6',
                                                        backgroundColor: '#3e98c7',
                                                    })}>
                                                        <div style={{ fontSize: '16px' }}>
                                                            {Math.round(parseFloat(this.props.sessionData.insightHorizontalConsistency[1]))}%
                                            </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 stat-circular-progress">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 30 }} />
                                        ) : (
                                                <IntlMessages id="mySession.insight.backliftDirectionAngle" />
                                            )}
                                    </div>
                                </div>
                                <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
                                    <div className="col-md-6 col-sm-12 col-6">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" className="stat-circular-progress-margin" style={{ height: 75 }} />
                                        ) : (
                                                <div className="stat-circular-progress-margin">
                                                    <CircularProgressbarWithChildren value={Math.round(parseFloat(this.props.sessionData.insightHorizontalConsistency[2]))} maxValue={100} styles={buildStyles({
                                                        pathTransitionDuration: 0.5,
                                                        pathColor: '#0099FF',
                                                        textColor: '#f88',
                                                        trailColor: '#c3e4fa',
                                                        backgroundColor: '#3e98c7'
                                                    })}>
                                                        <div style={{ fontSize: '16px' }}>
                                                            {Math.round(parseFloat(this.props.sessionData.insightHorizontalConsistency[2]))}%
                                            </div>
                                                    </CircularProgressbarWithChildren>
                                                </div>
                                            )}
                                    </div>
                                    <div className="col-md-6 col-sm-12 col-6 stat-circular-progress">
                                        {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                            <Skeleton animation="wave" variant="rect" style={{ height: 30 }} />
                                        ) : (
                                                <IntlMessages id="mySession.insight.batfaceAngle" />
                                            )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-12 col-12" style={{ paddingLeft: '5px' }}>
                        <div className="card jr-card-intra shadow text-center">
                            <div className="card-header px-3 py-3 align-items-center">
                                <h4 className="mb-0"><IntlMessages id="mySession.insight.facts" /></h4>
                            </div>
                            <div className="stack-order py-4 px-2 stat-min-height">
                                {this.props.sessionListLoader || this.props.sessionDataLoader || this.props.sessionData === null || this.props.playerInView === null || this.props.playerUid !== this.props.playerInView.uid ? (
                                    <div>
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                        <Skeleton animation="wave" variant="rect" className="my-2" style={{ height: 50 }} />
                                    </div>
                                ) : (
                                        <InsightMessages feature="horizontal" featureData={this.props.sessionData.insightHorizontalMessages} />
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    drawSwingGraphs() {
        var localSpeedData = []
        var localBackliftDirectionData = []
        var localBatFaceData = []
        var localEfficiencyData = []
        var localTimeToImpactData = []
        var localVerticalBackliftData = []
        var localHorizontalBackliftData = []
        var localVerticalDownswingData = []
        var localHorizontalDownswingData = []
        var localPowerData = []
        if (this.props.swingList.length > 0) {
            for (var i = 0; i < this.props.swingList.length; i++) {
                localSpeedData.push(
                    {
                        x: this.props.swingList[i].swingNum,
                        "Max Bat Speed": this.props.swingList[i].maxSpeed,
                        "Bat Speed at Impact": this.props.swingList[i].impactSpeed
                    }
                )
                localBackliftDirectionData.push(
                    {
                        x: this.props.swingList[i].swingNum,
                        "Backlift Direction Angle": this.props.swingList[i].backliftDirection
                    }
                )
                localBatFaceData.push(
                    {
                        x: this.props.swingList[i].swingNum,
                        "Bat Face Angle": this.props.swingList[i].batFace
                    }
                )
                localEfficiencyData.push(
                    {
                        x: this.props.swingList[i].swingNum,
                        "Efficiency": this.props.swingList[i].efficiency
                    }
                )
                localTimeToImpactData.push(
                    {
                        x: this.props.swingList[i].swingNum,
                        "Time to Impact": this.props.swingList[i].timeToImpact
                    }
                )
                localPowerData.push(
                    {
                        x: this.props.swingList[i].swingNum,
                        "Power": this.props.swingList[i].powerFactor
                    }
                )
                if (this.props.swingList[i].verticalHorizontalShot === 1) {
                    localVerticalBackliftData.push(
                        {
                            x: this.props.swingList[i].swingNum,
                            "Backlift Angle": this.props.swingList[i].backliftAngle
                        }
                    )
                    localVerticalDownswingData.push(
                        {
                            x: this.props.swingList[i].swingNum,
                            "Downswing Angle": this.props.swingList[i].downswingAngle
                        }
                    )
                } else {
                    localHorizontalBackliftData.push(
                        {
                            x: this.props.swingList[i].swingNum,
                            "Backlift Angle": this.props.swingList[i].backliftAngle
                        }
                    )

                    localHorizontalDownswingData.push(
                        {
                            x: this.props.swingList[i].swingNum,
                            "Downswing Angle": this.props.swingList[i].downswingAngle
                        }
                    )
                }
            }
            if (localVerticalBackliftData.length === 0) {
                localVerticalBackliftData = [{
                    x: "",
                    "Backlift Angle": ""
                }]
                localVerticalDownswingData = [{
                    x: "",
                    "Downswing Angle": ""
                }]
            }
            if (localHorizontalBackliftData.length === 0) {
                localHorizontalBackliftData = [{
                    x: "",
                    "Backlift Angle": ""
                }]
                localHorizontalDownswingData = [{
                    x: "",
                    "Downswing Angle": ""
                }]
            }
        } else {
            localSpeedData = [{
                x: "",
                "Max Bat Speed": "",
                "Bat Speed at Impact": ""
            }]
            localBackliftDirectionData = [{
                x: "",
                "Backlift Direction Angle": ""
            }]
            localBatFaceData = [{
                x: "",
                "Bat Face Angle": ""
            }]
            localEfficiencyData = [{
                x: "",
                "Efficiency": ""
            }]
            localTimeToImpactData = [{
                x: "",
                "Time to Impact": ""
            }]
            localVerticalBackliftData = [{
                x: "",
                "Backlift Angle": ""
            }]
            localHorizontalBackliftData = [{
                x: "",
                "Backlift Angle": ""
            }]
            localVerticalDownswingData = [{
                x: "",
                "Downswing Angle": ""
            }]
            localHorizontalDownswingData = [{
                x: "",
                "Downswing Angle": ""
            }]
            localPowerData = [{
                x: "",
                "Power": ""
            }]
        }
        this.setState({
            speedData: localSpeedData,
            backliftDirectionData: localBackliftDirectionData,
            batFaceData: localBatFaceData,
            efficiencyData: localEfficiencyData,
            timeToImpactData: localTimeToImpactData,
            verticalBackliftData: localVerticalBackliftData,
            horizontalBackliftData: localHorizontalBackliftData,
            verticalDownswingData: localVerticalDownswingData,
            horizontalDownswingData: localHorizontalDownswingData,
            powerData: localPowerData
        })
    }

    render() {
        return (
            <div className="module-box-content" style={{ margin: '10px 10px 10px 10px' }}>
                {this.renderSessionSummary()}
                {this.renderSessionOverall()}
                {this.renderSessionVertical()}
                {this.renderSessionHorizontal()}
                {/* Swings Charts */}
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                        <CardBox heading="Max Bat Speed Vs Bat Speed at Impact">
                            {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                            ) : (
                                    <StanceBeamDoubleBarChart chartData={this.state.speedData} firstBarColor="#ffc658" secondBarColor="#6399A3" />
                                )}
                        </CardBox>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                        <CardBox heading="Backlift Direction Angle">
                            {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                            ) : (
                                    <StanceBeamBarChart chartData={this.state.backliftDirectionData} barColor="#ffc658" />
                                )}
                        </CardBox>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                        <CardBox heading="Bat Face Angle">
                            {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                            ) : (
                                    <StanceBeamBarChart chartData={this.state.batFaceData} barColor="#6399A3" />
                                )}
                        </CardBox>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                        <CardBox heading="Efficiency">
                            {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                            ) : (
                                    <StanceBeamBarChart chartData={this.state.efficiencyData} barColor="#ffc658" />
                                )}
                        </CardBox>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                        <CardBox heading="Time to Impact">
                            {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                            ) : (
                                    <StanceBeamBarChart chartData={this.state.timeToImpactData} barColor="#6399A3" />
                                )}
                        </CardBox>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                        <CardBox heading="Backlift Angle">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                    {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                        <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                    ) : (
                                            <div>
                                                <div style={{ marginTop: '-10px' }} className="text-center">Vertical Bat Swings</div>
                                                <StanceBeamBarChart chartData={this.state.verticalBackliftData} barColor="#ffc658" />
                                            </div>
                                        )}
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                    {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                        <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                    ) : (
                                            <div>
                                                <div style={{ marginTop: '-10px' }} className="text-center">Horizontal Bat Swings</div>
                                                <StanceBeamBarChart chartData={this.state.horizontalBackliftData} barColor="#6399A3" />
                                            </div>
                                        )}
                                </div>
                            </div>
                        </CardBox>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                        <CardBox heading="Downswing Angle">
                            <div className="row">
                                <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                    {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                        <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                    ) : (
                                            <div>
                                                <div style={{ marginTop: '-10px' }} className="text-center">Vertical Bat Swings</div>
                                                <StanceBeamBarChart chartData={this.state.verticalDownswingData} barColor="#ffc658" />
                                            </div>
                                        )}
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                                    {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                        <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                                    ) : (
                                            <div>
                                                <div style={{ marginTop: '-10px' }} className="text-center">Horizontal Bat Swings</div>
                                                <StanceBeamBarChart chartData={this.state.horizontalDownswingData} barColor="#6399A3" />
                                            </div>
                                        )}
                                </div>
                            </div>
                        </CardBox>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                        <CardBox heading="Power">
                            {this.props.swingListLoader || this.props.sessionListLoader || this.props.sessionDataLoader || this.props.swingList.length === 0 || this.props.sessionData === null || this.props.sessionData.id !== this.props.sessionId ? (
                                <Skeleton animation="wave" variant="rect" style={{ height: 150, width: '100%' }} />
                            ) : (
                                    <StanceBeamBarChart chartData={this.state.powerData} barColor="#ffc658" />
                                )}
                        </CardBox>
                    </div>
                </div>
            </div>


        );
    }

}

const mapStateToProps = ({ session, player, swing }) => {
    const { playerInView } = player;
    const { sessionData, sessionDataLoader, sessionDataError, sessionListLoader, playerUid } = session;
    const { swingList, swingListLoader, swingListError, sessionId } = swing;
    return { playerInView, sessionData, sessionDataLoader, sessionDataError, sessionListLoader, playerUid, swingList, swingListLoader, swingListError, sessionId }
};

export default connect(mapStateToProps)(Insight);